import CheckIcon from '@mui/icons-material/Check';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import '@/Pages/Success/SuccessPage.sass';

type SuccessSummaryItemProps = {
  label: string;
  value: string;
};

export function SuccessSummaryItem({
  label,
  value,
}: SuccessSummaryItemProps): JSX.Element {
  return (
    <Box
      component="li"
      className="success-summary-item"
      data-testid="success-summary-item"
    >
      <Box className="success-summary-item__content">
        <Typography component="span" className="success-summary-item__label">
          {label}
        </Typography>
        <Typography component="span" className="success-summary-item__value">
          {value}
        </Typography>
      </Box>
      <Box
        className="success-summary-item__check"
        aria-hidden="true"
        data-testid="success-summary-item-check"
      >
        <CheckIcon fontSize="small" />
      </Box>
    </Box>
  );
}
